import React, { createContext, useContext, useEffect, useRef, useState } from "react";
import api, { formatApiError, setToken } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = unauth, object = authed
  const authedRef = useRef(false);

  useEffect(() => {
    api
      .get("/auth/me")
      // A late-resolving bootstrap check must never clobber a user that logged in
      // while it was still in flight.
      .then((res) => { if (!authedRef.current) setUser(res.data); })
      .catch(() => { if (!authedRef.current) setUser(false); });
  }, []);

  const login = async (email, password, mfaCode, recoveryCode) => {
    try {
      const { data } = await api.post("/auth/login", {
        email, password,
        mfa_code: mfaCode || null,
        recovery_code: recoveryCode || null,
      });
      if (data.access_token) setToken(data.access_token);
      const me = await api.get("/auth/me");
      authedRef.current = true;
      setUser(me.data);
      return { ok: true, data };
    } catch (e) {
      return { ok: false, error: formatApiError(e.response?.data?.detail) || e.message };
    }
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {}
    authedRef.current = false;
    setToken(null);
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
